import { useSelector } from "react-redux";
import { ApplicationState } from "..";
import { EntitiesData, Entity, EntityType } from "./state";
import { getEntitiesData, getEntitiesDataItems, getEntitiesSearchItems, getEntity } from "./selectors";

export const useEntities = <T extends Entity>(type: EntityType): T[] => {
    return useSelector<ApplicationState, Entity[]>(state => getEntitiesDataItems<T>(type)(state)) as T[];
};

export const useEntity = <T extends Entity>(type: EntityType, id: string): T|undefined => {
    return useSelector<ApplicationState, T|undefined>(state => getEntity<T>(state, type, id));
};

export const useEntitiesData = <T extends Entity>(type: EntityType): EntitiesData<T> => {
    return useSelector<ApplicationState, EntitiesData<T>>(getEntitiesData<T>(type));
};

export const useEntitiesResult = <T extends Entity>(type: EntityType): T[] => {
    return useSelector<ApplicationState, Entity[]>(state => getEntitiesSearchItems<T>(state, type)) as T[];
};
